// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import UsersController from "./users_controller"
application.register("users", UsersController)

import PresentationController from "./presentation_controller"
application.register("presentations", PresentationController)
